<template>
  <div class="c-journey-con">
    <journey-add-follow :customeId="customeId" :baseInfo="baseInfo" v-if="baseInfo.allow_follow_up" />
    <div class="follow-condition">
      <el-cascader 
        placeholder="跟进类型"
        class="add-style-text" 
        :options="customeFollowType"
        :props="{multiple: true, emitPath: false}" 
        v-model="condition.type"
        @change="reload" clearable 
      ></el-cascader>
      <el-select class="add-style-text"  v-model="condition.admin_id" placeholder="跟进人" :remote-method="handleAdminSearch" @change="reload" :loading="adminLoading" filterable remote reserve-keyword multiple clearable>
          <el-option v-for="admin in adminList" :key="admin.admin_id" :value="admin.admin_id" :label="admin.admin_name"></el-option>
      </el-select>
      <el-date-picker class="follow-time-picker" v-model="followTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options="timeOptions" @change="handleChangeFollow" clearable>
      </el-date-picker>
    </div>
    <div class="flex-scroll" v-if="logList.length > 0">
      <div class="follow-items" v-for="(log, i) in logList" :key="i">
        <p class="show-time">{{getTimelineDate(log.date)}}</p>
        <template v-for="(item, p) in (log.list || [])">
          <div class="time-line-item" :key="`item_${p}`">
            <p class="tl-line"></p>
            <span class="tl-time">{{getTimelineTime(item.created_time)}}</span>
            <i class="iconfont tl-image" :class="imgList[item.type]"></i>
            <div class="tl-content">
              <h1 class="tl-username">{{item.type_name || ''}}
                <!-- 400展示 -->
                <p v-if="item.type == 7" class="call-remain-time">{{getCallDesc(item.call_info)}}</p>
              </h1>
              <!-- 审批状态以及时间展示 -->
              <div class="approve-style" v-if="item.type === 5">
                <span class="approve-status" :class="`approve-status-${item.approval_info.check_status}`">{{item.approval_info.status_show || ''}}</span>
                <span class="approve-time">{{getApproveTime(item)}}</span>
              </div>
              <!-- 内容展示 -->
              <template v-if="[10, 14, 4,17].indexOf(item.type) < 0 && item.type != 14 && item.content && item.content.length > 0">
                <div class="tl-desc" v-for="(desc, l) in item.content" :key="`${p}_${item.id}_${l}`">
                  <p v-html="generateDesc(desc, item)" class="tl-inline"></p>
                  <!-- 审批/跟进查看详情 -->
                  <a class="look-more" v-if="[4,5].indexOf(item.type) >= 0 && l === 0" @click="handleRedirect(item.page_to)">详情></a>
                  <!-- IM详情跳转 -->
                  <a class="look-more" v-if="item.type == 8 && l === 0 && item.im_info.has_record > 0 && item.im_info.count > 0" @click="toImList(item)">详情></a>
                </div>
              </template>
              <!-- 云门店解绑 -->
              <p v-if="item.bind_shop_info && item.bind_shop_info.unbind_time && item.bind_shop_info.unbind_time > 0" class="tl-data">
                {{parseTime(item.bind_shop_info.unbind_time, `{y}-{m}-{d} {h}:{i}:{s}`)}} 已解绑关联关系
              </p>
              <!-- 企微解绑 -->
              <p v-if="item.type ==13 && item.bind_wework_info && item.bind_wework_info.unbind_time && item.bind_wework_info.unbind_time > 0" class="tl-data">
                {{parseTime(item.bind_wework_info.unbind_time, `{y}-{m}-{d} {h}:{i}:{s}`)}} 已解绑关联关系
              </p>
              <!-- 轨迹浏览记录 -->
              <div :class="moreRecord == item.id && 'recorder-guiji-list'" v-if="item.type === 10 && item.shop_track_info">
                <template v-if="moreRecord != item.id">
                  <template v-if="item.content && item.content.length > 0">
                    <div class="tl-desc" v-for="(desc, l) in item.content" :key="`${p}_${item.id}_${l}`">
                      <p v-html="generateDesc(desc, item)" class="tl-inline"></p>
                    </div>
                  </template>
                  <p class="tl-data">
                    {{item.shop_track_info.visit_statistic_content || ''}}
                  </p>
                  <div class="tl-review-list">
                    <span class="tl-count">共有 {{item.shop_track_info.count || 0}} 条访问记录</span>
                    <a v-if="item.shop_track_info.count > 1 && moreRecord !== item.id" class="look-more look-close-recorde" style="margin-top:0;" @click="moreRecord = moreRecord === item.id ? '' : item.id">
                      查看浏览记录>
                    </a>
                  </div>
                </template>
                <div v-for="(visitotRecord, v_i) in item.shop_track_info.list" class="custome-visitor-log" v-if="moreRecord == item.id">
                  <p class="tl-line" v-if="(v_i + 1) !=  item.shop_track_info.count"></p>
                  <span class="tl-time">{{getTimelineTime(visitotRecord.created_at, true)}}</span>
                  <span class="tl-visitor-round"></span>
                  <div>
                    <p v-html="generateDesc(visitorRecordCh, item, visitotRecord)" v-for="(visitorRecordCh, i_c) in visitotRecord.content" class="tl-desc"></p>
                    <div class="tl-review-list">
                      <span class="tl-count">浏览次数：{{visitotRecord.count}} 次</span>
                      <span class="tl-data">浏览时长： {{timeConvertUtil(visitotRecord.duration)}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 400记录：type/7 -->
              <template v-else-if="item.type === 7">
                <span class="tl-data block">{{parseTime(item.call_info.end_time, `{y}-{m}-{d} {h}:{i}:{s}`)}} 挂断电话</span>
                <!-- 判断是否有/展示录音 -->
                <div v-if="item.call_info && item.call_info.has_record === 1">
                  <audio-player :item="item" :activeName="activeName" />
                </div>
              </template>
              <!-- IM聊天对应操作与信息 -->
              <template v-if="item.type === 8">
                <div class="tl-desc" v-if="item.im_info" style="padding-top:7px;">
                  <span class="im-label" v-if="item.im_info.first_tel_desc">{{item.im_info.first_tel_desc}}</span>
                  <span class="im-label" v-if="item.im_info.count > 0">共{{item.im_info.count || 0}}条记录</span>
                </div>
              </template>
              <template v-if="item.type === 10 && item.shop_track_info">
                <a v-if="item.shop_track_info.count > 1 && moreRecord == item.id" class="look-more look-close-recorde" @click="moreRecord = moreRecord === item.id ? '' : item.id">
                  收起浏览记录>
                </a>
              </template>
              <!-- 浏览记录 -->
              <template v-if="item.type === 14">
                <div class="tl-desc" v-for="(desc, l) in item.content" :key="`${p}_${item.id}_${l}`">
                  <p v-html="replaceContent(desc, item.platform_track_info)" class="tl-inline"></p>
                </div>
                <span class="im-label" style="margin-top: 8px;" v-if="isShowAccount(item.platform_track_info.visit_time)">共{{item.platform_track_info && item.platform_track_info.count || 0}}条记录</span>
                <span class="look-more" @click="lookMoreRecord(item, log.date)" style="display:block;margin-left:0;margin-top:10px;">查看完整浏览记录></span>
              </template>
              <!-- 写跟进 -->
              <div v-if="item.type == 4" class="track-add-follow-con">
                <p class="track-follow-base">{{item.follow_info.operator}}提交了{{item.follow_info.type_name}} - {{item.follow_info.way_name}}
                  <span v-if="item.follow_info.way == 2 && item.follow_info.sub_way_name">（{{item.follow_info.sub_way_name}}）</span>
                </p>
                <p class="track-content" v-if="item.follow_info.next_follow_up_time > 0">下次跟进时间：{{ parseTime(item.follow_info.next_follow_up_time) }}</p>

                <div v-if="item.follow_info.labels && item.follow_info.labels.length > 0" class="track-labels">
                  <span v-for="(item, key) in item.follow_info.labels" :key="key">{{item}}</span>
                </div>
                <p class="track-content" v-if="item.follow_info.remark">跟进内容如下：{{item.follow_info.remark}}</p>
                <div v-if="item.follow_info.common_update && item.follow_info.common_update.length > 0" class="track-table-con">
                  <p class="track-table-title">{{item.follow_info.is_first_update == 0 ? '基本资料更新:' : '基本资料重新评估为：'}}</p>
                  <div class="track-table">
                    <div v-for="(item, key) in item.follow_info.common_update" :key="key" class="track-table-item">
                      <p class="track-head">{{item.name}}</p>
                      <p class="track-body">{{item.val}}</p>
                    </div>
                  </div>
                </div>
                <div v-if="item.follow_info.thread_update && item.follow_info.thread_update.length > 0" class="track-table-con">
                  <p class="track-table-title">{{item.follow_info.is_first_update == 0 ? '购房意向更新:' : '购房意向重新评估为：'}}</p>
                  <div class="track-table">
                    <div v-for="(item, key) in item.follow_info.thread_update" :key="key" class="track-table-item">
                      <p class="track-head">{{item.name}}</p>
                      <p class="track-body">{{item.val}}</p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 修改客户资料(兼容旧数据，做一个content判断) -->
              <div v-if="item.type == 2 && item.content.length <= 0" class="track-add-follow-con">
                <div v-if="item.edit_info.labels && item.edit_info.labels.length > 0" class="track-labels">
                  <span v-for="(item, key) in item.edit_info.labels" :key="key">{{item}}</span>
                </div>
               <!-- <p>{{item.edit_info.operator}}修改了客户资料</p>-->
                <div v-if="item.edit_info.common_update && item.edit_info.common_update.length > 0" class="track-table-con">
                  <p class="track-table-title"> {{item.edit_info.is_first_update == 0 ? '基本资料更新:' : '基本资料重新评估为：'}}</p>
                  <div class="track-table">
                    <div v-for="(item, key) in item.edit_info.common_update" :key="key" class="track-table-item">
                      <p class="track-head">{{item.name}}</p>
                      <p class="track-body">{{item.val}}</p>
                    </div>
                  </div>
                </div>
                <div v-if="item.edit_info.thread_update && item.edit_info.thread_update.length > 0" class="track-table-con">
                  <p class="track-table-title">{{item.edit_info.is_first_update == 0 ? '购房意向更新:' : '购房意向重新评估为：'}}</p>
                  <div class="track-table">
                    <div v-for="(item, key) in item.edit_info.thread_update" :key="key" class="track-table-item">
                      <p class="track-head">{{item.name}}</p>
                      <p class="track-body">{{item.val}}</p>
                    </div>
                  </div>
                </div>
              </div>
              <!--抖音访客-->
              <div v-if="item.type == 17 && item.douyin_track_info.account_id" >
                <div class="tl-desc" v-for="(desc, l) in item.content" :key="`${p}_${item.id}_${l}`">
                  <p v-html="generateDesc(desc, item)" class="tl-inline"></p>
                  <!-- 抖音访客查看详情 -->
                  <a class="look-more"  @click="handleRedirectVisitor(item)">查看明细>></a>
                 
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div v-else-if="!isLoading && logList.length <= 0" class="journey-empty-group">
      <img :src="require('@/assets/images/none-data.png')" />
      <p>未找到相关数据</p>
    </div>
    <template v-if="logList.length > 0">
      <p class="load-more" v-if="isLoading">
        <i class="el-icon-loading"></i>
      </p>
      <p v-else-if="hasMore" class="load-more" @click="loadMore">查看更多旅程</p>
      <p class="load-more load-end-label" v-else>访客就浏览到这里咯</p>
    </template>
    <chat-records ref="chatRecords" />
  </div>
</template>
<script>
import { configKeys } from '@/setting/index';
import {getGunrneyList, customeFollowAdd, getGunrneyAdmin, downloadCallRecord, getEnterPrisePermission, getVisitorPermission} from '@/api/custome';
import { parseTime, formatTime, timeConvertUtil } from '@/utils/index';
import {validatRemark} from '@/utils/validate';
import { mapState } from 'vuex';
import SingleAutoComplete from '@/components/select/SingleAutoComplete';
import JourneyAddFollow from './journeys/addFollow';
export default{
  name: "DetailJourney",
  components: {
    SingleAutoComplete,
    JourneyAddFollow,
    chatRecords: resolve=>(require(["./imRecord"],resolve)),
    AudioPlayer: resolve=>(require(["./journeys/audio"],resolve)),
  },
  props: {
    customeId: [String, Number],
    activeName: String,
    baseInfo: Object,
    activeType: Array
  },
  data () {
    return {
      path: '',
      downloading: '',
      playing: '', // 正在缓冲的播放
      options: {},
      followType: '',
      followContent: '',
      followTime: [],
      timeOptions: {},
      condition: {
        page: 1,
        per_page: 20,
        created_at_start: '',
        created_at_end: '',
        admin_id: [],
        type: []
      },
      logList: [],
      imgList: {
        1: 'iconjia',
        2: 'iconxiugai',
        3: 'iconbiangeng',
        4: 'iconxiugai',
        5: 'iconshenpi-lv',
        6: 'iconshenpi-lv',
        7: 'icondianhua',
        8: 'iconliaotian-04',
        9: 'iconshenqingxiezhu',
        10: 'iconchakan',
        11: 'iconicon_tips',
        12: 'iconlianjie1',
        13: 'iconlianjie1',
        14: 'iconchakan',
        15: 'iconjinxianlei',
        16: 'iconxiugai',
        17: 'iconzuji'
      },
      hasMore: false,
      isLoading: false,
      adminList: [],
      adminLoading: false,
      customeFollowType: [],
      moreRecord: '',
      parseTime,
      timeConvertUtil,
    }
  },
  computed: {
    ...mapState({
      emitName: state => state.const.emitName
    })
  },
  async created() {
    if(this.activeType.length) this.condition.type = this.activeType
    this.initLogList();
    this.options = await this.$store.dispatch('initConfig', [configKeys.customer_route_type, configKeys.follow_up_custom_ways]);
    this.customeFollowType = Object.keys(this.options.customer_route_type).map(v => ({label: this.options.customer_route_type[v], value: v}));
    this.handleAdminSearch('');
  },
  methods: {
    refreshData(){
      this.initLogList();
    },
    replaceContent (data, item) {
      let content = data;
      // 匹配最长楼盘
      if (item.longest_project_url) {
        content = content.replaceAll(item.longest_project, `<a class="pre-relative" href="${item.longest_project_url}" target="_blank">${item.longest_project}</a>`);
      }
      // 匹配最长文章
      if (item.longest_article_url) {
        content = content.replaceAll(item.longest_article, `<a class="pre-relative" href="${item.longest_article_url}" target="_blank">${item.longest_article}</a>`);
      }
      return content;
    },
    isShowAccount (time) {
      const date = new Date().getDate();
      const origin = new Date(time * 1000).getDate();
      return date != origin;
    },
    generateDesc (desc = '', item = {}, itemChild = {}) {
      let name = item?.page_to?.extra?.replace || '';
      let content = desc;
      let replaceName = '';
      let pageInfo = item.page_to;
      // 浏览信息展示
      if (item.type == 10) {
        name = item?.shop_track_info?.main_from_visitor_name || '';
        pageInfo = {
          page: pageInfo.page,
          extra: {
            shop_visitor_id: itemChild.from_visitor_id || item.visitor_id,
            admin_id: item.shop_id
          }
        }
      }
      if (name !== '') {
        content = content.replace(name, `<span class="jouney-relative-detail" pageid='${JSON.stringify(pageInfo)}'>${name}</span>`);
      }
      return content;
    },
    // 初始化用户详情点击
    initEvent () {
      this.$nextTick(() => {
        const list = document.querySelectorAll('.c-journey-con .jouney-relative-detail');
        if (!list) return null;
        for(let i = 0; i <list.length; i ++) {
          list[i].onclick = () => {
            let page = list[i].getAttribute('pageid');
            if (page) page = JSON.parse(page);
            this.handleRedirect(page);
          }
        }
      })
    },
    // 处理页面点击事件
    handleRedirect (item) {
      if (item.page === 'wework_customer_detail') {
        this.handleWeworkDetail(item.extra);
        return null;
      }
      if (item.page === 'shop_visitor_detail') {
        this.handleVisitorDetail(item.extra);
        return null;
      }
      if (item.page === 'follow_detail') {
        this.$EventBus.$emit(this.emitName, {category: 'follow', params: {
          followType: 'custome', 
          type: 'show', 
          followId: item?.extra.id || ''
        }})
      }
      if (item.page === 'approval_detail') {
        this.$EventBus.$emit(this.emitName, {category: 'approve', params: {
          voucher_type: item?.extra?.voucher_type || '', 
          approvalId: item?.extra?.approval_id || ''
        }})
      }
    },
    handleRedirectVisitor(item){
      this.$EventBus.$emit(this.emitName, {category: 'yunVisitorDetail', params: {
        visitorId: item.douyin_track_info.account_id,
        traceInfo:item
      }});
    },
    // 企微详情
    async handleWeworkDetail (data = {}) {
      try {
        const res = await getEnterPrisePermission(data.wework_customer_id, {
          wework_user_id: data.wework_user_id || ''
        });
        const belongs = (res.belongs || []).map(v => {
          return {
            ...v,
            clew_id: data.wework_customer_id,
          }
        })
        this.$EventBus.$emit(this.emitName, {category: 'clewDetail', params: {
          belongs: belongs,
          activeName: `${res.target_wework_user_id}_${data.wework_customer_id}`
        }})
      } catch (err) {
        this.$message.error(err.msg || '操作失败，请重试'); 
      }
    },
    // 云门店详情
    async handleVisitorDetail (data = {}) {
      try {
        const res = await getVisitorPermission(data.shop_visitor_id, {
          admin_id: data.admin_id || 0
        });
        this.$EventBus.$emit(this.emitName, {category: 'visitorDetail', params: {
          visitor_id: data.shop_visitor_id,
          admin_id: res.target_admin_id, 
          condition: {}
        }})
      } catch (err) {
        this.$message.error(err.msg || '操作失败，请重试'); 
      }
    },
    toImList (item) {
      this.$refs?.chatRecords?.open(item);
    },
    async handleAdminSearch (keyword = '') {
      this.adminLoading = true;
      try {
        const res = await getGunrneyAdmin({
          customer_id: this.customeId,
          keyword
        })
        this.adminList = res;
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      } finally {
        this.adminLoading = false;
      }
    },
    handleChangeFollow () {
      this.condition.created_at_start = this.followTime?.[0] ?? '';
      this.condition.created_at_end = this.followTime?.[1] ?? '';
      this.reload();
    },
    fixNum (a) {
      return a < 10 ? `0${a}` : a;
    },
    getTimelineTime (time, isFullTime) {
      if (time) {
        const before = isFullTime ? new Date(time) : new Date(time * 1000);
        const now = Date.now();
        const diff = (now - before.getTime()) / 1000;
        if (diff < 3600) return Math.ceil(diff / 60) + '分钟前';
        else return `${this.fixNum(before.getHours())}:${this.fixNum(before.getMinutes())}:${this.fixNum(before.getSeconds())}`;
      } else {
        return '';
      }
    },
    getTimelineDate (date) {
      if (date) {
        const now = new Date();
        const pNow = new Date(`${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`);
        const pDate = new Date(date);
        const isDay = (now - pDate) / 1000 / 60 / 60 / 24;
        const dateStr = `${pDate.getFullYear()}年${pDate.getMonth() + 1}月${pDate.getDate()}日`;
        if (parseInt(isDay) === 0) return `今天 ${dateStr}`;
        else if (parseInt(isDay) <= 6) return `周${['天', '一', '二', '三', '四', '五', '六'][pDate.getDay()]} ${dateStr}`;
        else return dateStr;
      }
      return date;
    },
    async initLogList () {
      this.isLoading = true;
      try {
        const params = {
          customer_id: this.customeId,
          ...this.condition
        }
        params.admin_id = params.admin_id.join(',');
        if (!params.admin_id) delete params.admin_id;
        params.type = params.type.join(',');
        const res = await getGunrneyList(params);
        const list = res.data ?? [];
        if (this.condition.page === 1) {
          this.logList = list;6
        } else {
          const logs = this.logList;
          list.map(v => {
            const isExitIndex = logs.findIndex(m => m.date === v.date);
            if (isExitIndex >= 0) {
              logs[isExitIndex].list = logs[isExitIndex].list.concat(v.list);
            } else {
              logs.push(v);
            }
          })
        }
        this.hasMore = res.to !== res.total;
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试'); 
      } finally {
        this.isLoading = false;
        this.$nextTick(_ => {
          this.initEvent();
        })
      }
    },
    loadMore () {
      this.condition.page += 1;
      this.initLogList();
    },
    reload () {
      this.condition.page = 1;
      this.logList = [];
      this.initLogList();
    },
    getApproveTime (data) {
      const time = data?.approval_info?.approval_time ?? '';
      if (!time) return '';
      return parseTime(time);
    },
    toApproveDetail (item) {
      this.$EventBus.$emit(this.emitName, {category: 'approve', params: {
        tabActiveName: this.activeName,
        voucher_type: item?.sub_type ?? '',
        approvalId: item?.approval_id ?? '',
      }})
    },
    
    // 解析400时间
    analysisTime (item) {
      const parseTime = item?.call_info?.call_time ?? 0;
      const now = Date.now();
    },
    lookMoreRecord (data, date) {
      this.$emit('handleUpdateRecord', {
        ...data.platform_track_info,
        searchDate: date
      });
    },
    getCallDesc (call_info = {}) {
      // 超过三个月
      if (!call_info.call_time || call_info.call_time + (90 * 24 * 60 * 60) < new Date().getTime() / 1000) {
        return '(通话记录仅保存3个月)';
      }
      if (call_info.has_record === 1) {
        return '(通话记录仅保存3个月)';
      }
      if (call_info.has_permission == 1) {
        return '(由于通话时间过短，未生成通话记录)';
      }
      return '';
    }
  },
}
</script>
<style lang="less" scoped>
.call-remain-time{
  display: inline-block;
  font-size: 12px;
  color: #999;
  margin-left: 10px;
}
.download-loading{
  background: #FFF;
  border: 1px solid #E8E8E8;
  color: #666666;
  display: inline-block;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 3px;
  padding: 0 10px;
  font-size: 12px;
}
.tl-image{
  width: 23px;
  height: 23px;
  background: #3f80fe;
  color: #fff;
  font-weight: normal;
  border-radius: 50%;
  text-align: center;
  line-height: 23px;
  font-size: 11px;
}
.tl-image.iconxiugai{
  background: #0fb37b;
}
.tl-image.iconbiangeng{
  background: #ff6a00;
}
.tl-image.iconicon_tips{
  background: #ff7916;
}
.tl-image.iconlianjie1{
  background: #0fb07c;
}
.track-add-follow-con{
  .track-follow-base{
    color: #333333;
    font-size: 14px;
    span{
      color: #999;
    }
  }
  .track-labels{
    margin-top: 10px;
    span{
      height: 22px;
      background: #DAFFF2;
      border-radius: 11px;
      line-height: 22px;
      color: #15B77E;
      padding: 0 10px;
      font-size: 12px;
      margin-right: 10px;
      display: inline-block;
    }
  }
  .track-content{
    margin-top: 12px;
    color: #333333;
    font-size: 14px;
    line-height: 20px;
  }
  .track-table-con{
    padding-bottom: 5px;
    .track-table-title{
      color: #333333;
      font-size: 14px;
      margin-top: 13px;
    }
  }
  .track-table{
    border: 1px solid #E8E8E8;
    width: 700px;
    margin-top: 13px;
    .track-table-item{
      .box();
      border-bottom: 1px solid #E8E8E8;
      &:last-child{
        border-bottom: 0;
      }
    }
    .track-head{
      background: #EEF5FF;
      color: #333333;
      font-size: 12px;
      font-weight: bold;
      width: 150px;
      text-align: center;
      padding: 10px 0;
      line-height: 20px;
    }
    .track-body{
      background: #fff;
      color: #333333;
      font-size: 12px;
      padding: 10px 15px;
      line-height: 20px;
      border-left: 1px solid #E8E8E8;
      .boxFlexAll();
    }
  }
}
</style>
<style lang="less">
.follow-admin-select{
  .el-select__tags>span{
    display: -webkit-box;
    width: 100%;
    overflow: hidden;
  }
  .el-tag.el-tag--info{
    height: 20px;
    line-height: 16px;
    display: block;
    margin-top: 5px;
  }
  .el-select__tags{
    height: 30px;
  }
}
.jouney-relative-detail{
  color: #0FB07C;
  display: inline-block;
  padding: 0 3px;
  cursor: pointer;
}
</style>